import { AxiosPromise } from "axios";
import configs from "../configs";
import { UserLiveApis } from "./live/userLiveApi";



export class UserApis {
    private static adminApi: UserLiveApis = new UserLiveApis();





    static trackShipment(id: any): AxiosPromise<Array<any>> {
        if (configs.type === "LOCAL") {
            return {} as AxiosPromise;
        } else {
            return this.adminApi.trackShipment(id);
        }
    }





}